import {
  getSingleLabel,
  getRangeLabel,
  getOptionLabel,
  removeOptionLabel,
} from './setTag';

export default {
  'sky-main-input': {
    getName(obj) {
      return getSingleLabel(obj);
    },
    remove(obj) {
      obj.value = '';
      return obj;
    },
  },
  'sky-mainInput': {
    getName(obj) {
      return getSingleLabel(obj);
    },
    remove(obj) {
      obj.value = '';
      return obj;
    },
  },
  'sky-input': {
    getName(obj) {
      return getSingleLabel(obj);
    },
    remove(obj) {
      return removeOptionLabel(obj);
    },
  },
  'sky-dropdown-select': {
    getName(obj) {
      return getOptionLabel(obj);
    },
    remove(obj, index) {
      return removeOptionLabel(obj, index);
    },
  },
  'sky-cascader': {
    getName(obj) {
      return getOptionLabel(obj);
    },
    remove(obj, index) {
      return removeOptionLabel(obj, index);
    },
  },
  'sky-range-input': {
    getName(obj) {
      return getRangeLabel(obj);
    },
    remove(obj) {
      obj.value = [];
      return obj;
    },
  },
  'sky-select': {
    getName(obj) {
      return getOptionLabel(obj);
    },
    remove(obj, index) {
      return removeOptionLabel(obj, index);
    },
  },
  // 'customer-search': {
  //   getName(obj) {
  //     return getOptionLabel(obj)
  //   },
  //   remove(obj, index) {
  //     return removeOptionLabel(obj, index)
  //   }
  // },
  'sky-date-range': {
    getName(obj) {
      return getRangeLabel(obj);
    },
    remove(obj) {
      obj.value = [];
      return obj;
    },
  },
  'sky-date-picker': {
    getName(obj) {
      if (obj.type === 'daterange') {
        return getRangeLabel(obj);
      } else {
        return getSingleLabel(obj);
      }
      // return getRangeLabel(obj)
    },
    remove(obj) {
      if (obj.type === 'daterange') {
        obj.value = [];
      } else {
        obj.value = '';
      }
      return obj;
    },
  },
  'sky-slider-extent': {
    getName(obj) {
      return getRangeLabel(obj);
    },
    remove(obj, index) {
      let val = removeOptionLabel(obj, index);
      return val;
    },
  },
  'sky-input-extent': {
    getName(obj) {
      return getRangeLabel(obj);
    },
    remove(obj) {
      let val = removeOptionLabel(obj);
      return val;
    },
  },
};
